/**
 * Central site configuration for SEO.
 * The real site origin comes from the VITE_SITE_URL environment variable.
 * A runtime fallback to the current browser origin is used only when the
 * environment variable is not available.
 */
export const SITE_NAME = '武汉俊鑫岚科技有限公司';

const envSiteUrl = (import.meta.env.VITE_SITE_URL as string | undefined)?.trim();

export const SITE_URL: string = (() => {
  if (envSiteUrl) {
    return envSiteUrl.replace(/\/+$/, '');
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/+$/, '');
  }
  return '';
})();

/**
 * Build an absolute URL for a given route path using the resolved site origin.
 */
export function absoluteUrl(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  if (!SITE_URL) {
    return normalized;
  }
  return `${SITE_URL}${normalized}`;
}